import { CheckoutCom3ds2Modal } from 'src/app/shared/components/CheckoutCom3ds2/CheckoutCom3ds2Modal';
import { useActor } from '@xstate/react';
import { useEffect, useState } from 'react';
import { CheckoutCom3ds2Status, confirmCheckoutCom3ds2 } from 'src/app/shared/components/CheckoutCom3ds2/confirm';
import useRetryPaymentService from '../xstate/useRetryPaymentService';

export const CheckoutCom3ds2ModalContainer = () => {
  const retryPaymentService = useRetryPaymentService();
  const [state, send] = useActor(retryPaymentService);

  const [redirectUrl, setRedirectUrl] = useState('');

  useEffect(() => {
    async function listenToMessage() {
      const status = await confirmCheckoutCom3ds2();
      if (status) {
        send({
          type: 'CONFIRM_PNR',
          is3ds2Success: status === CheckoutCom3ds2Status.SUCCESS,
          cardId: state.context.cardId || '',
          sessionId: state.context.sessionId || '',
        });
        setRedirectUrl('');
      }
    }

    listenToMessage();
  }, [send, state]);

  const handleDismiss = () => {
    setRedirectUrl('');
  };

  useEffect(() => {
    if (state.matches('3dSecure2')) {
      setRedirectUrl(state.context.redirectUrl);
    }
  }, [state, state.context.redirectUrl]);

  return <CheckoutCom3ds2Modal open={!!redirectUrl} closeModal={handleDismiss} redirectUrl={redirectUrl} />;
};
